import { render, staticRenderFns } from "./SAPView.vue?vue&type=template&id=819152e6"
import script from "./SAPView.vue?vue&type=script&lang=js"
export * from "./SAPView.vue?vue&type=script&lang=js"
import style0 from "./SAPView.vue?vue&type=style&index=0&id=819152e6&prod&lang=scss"
import style1 from "./SAPView.vue?vue&type=style&index=1&id=819152e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports